import gql from 'graphql-tag'

export const LogsListQuery = gql`
  query LogsListQuery($weld_id: ID!) {
    weld(weld_id: $weld_id) {
        id
        no
        weld_joint_type {
          weld_type {
            id
            name
          }
          joint_type {
            id
            name
          }
        }
        length
        thickness_1
        thickness_2
        material_1 {
          id
          name
        }
        material_2 {
          id
          name
        }
        diameter_1
        diameter_2
        welding_progress
        has_dimensional_control
        dc_weld_failed
        inspections
        status
        process_errors
        welder {
          date
        }
        extra_data
        wps {
          id
          no
          rev_no
          welder_certification_standards
        }
        welding_consumables {
          id
          name
        }
        inspection_category {
          id
          name
          inspections {
            type_id
            range
            company_id
            double_length
          }
        }
      welding_progress
      logs {
        id
        type
        note
        weld_failed
        complete
        complete_percent
        log_data
        date
        double_length
        gauging
        hold_time_bypassed
        created_at
        updated_at
        welding_consumables {
          id
          name
        }
        inspection_category_type {
          id
          name
        }
        person {
          id
          name
        }
        user {
          id
          email
          person {
            first_name
            last_name
          }
        }
        attachments {
          id
          data_file_name
          url
        }
        skipped
        weld_inspection_group_id
        wps {
          id
          no
        }
        wps_ids
      }
      project {
        id
        extra_columns
        parents {
          id
          name
        }
      }
    }
    inspection_log_data_types {
      id
      name
    }
    welding_log_data_types {
      id
      name
    }
    inspection_category_types {
      id
      name
    }
  }
`

export const destroyLogMutation = gql`
  mutation destroyLogs($id: ID!) {
    destroyLogs(id: $id) {
      response
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Logs/mutations.js